import { ChipVariants } from "components/Chip";

export const adjustmentTypesConstants = {
  MPDR: "MPDR",
  NCCI: "NCCI",
  BILATERAL: "Bilateral",
  CASE_RATE: "Case Rate",
  CASE_RATE_BILATERAL: "Case Rate Bilateral",
  ENDOSCOPY: "Endoscopy",
  BILATERAL_MPDR: "Bilateral + MPDR",
  ENDOSCOPY_MPDR: "Endoscopy + MPDR",
  PACKAGED_CODE: "Packaged Code",
  HIERARCHY_OVERRIDE: "Hierarchy Override",
  MUE: "MUE",
  CHARGE_BASED_PRICING_CAP: "CHARGE_BASED_PRICING_CAP",
};

export const adjustmentTypesMapping = {
  [adjustmentTypesConstants.MPDR]: "Multiple Procedure Discount Applied",
  [adjustmentTypesConstants.NCCI]: "National Coding Correction Applied",
  [adjustmentTypesConstants.BILATERAL]:
    "Bilateral Procedure Adjustment Applied",
  [adjustmentTypesConstants.CASE_RATE]: "Case Rate Adjustment Applied",
  [adjustmentTypesConstants.CASE_RATE_BILATERAL]:
    "Case Rate Bilateral Adjustment Applied",
  [adjustmentTypesConstants.ENDOSCOPY]: "Base Endoscopy Adjustment Applied",
  [adjustmentTypesConstants.BILATERAL_MPDR]:
    "Bilateral + Multiple Procedure Discounts Applied",
  [adjustmentTypesConstants.ENDOSCOPY_MPDR]:
    "Endoscopy + Multiple Procedure Discounts Applied",
  [adjustmentTypesConstants.PACKAGED_CODE]: "Packaged Code",
  [adjustmentTypesConstants.HIERARCHY_OVERRIDE]: "Hierarchy Override Applied",
  [adjustmentTypesConstants.MUE]: "MUE Adjustment applied",
  [adjustmentTypesConstants.CHARGE_BASED_PRICING_CAP]:
    "Charge-Based Pricing Cap Applied",
};

export const orderTypeConstants = {
  ED: "ED",
  BUNDLED: "Bundled",
  PATIENT_RESPONSIBILITY: "PatientResponsibility",
  BARIATRICS: "Bariatrics",
  GFE: "GFE",
};

// Sentinel date of service (MM/DD/YYYY) carried by orders whose visit has not
// been scheduled yet. There is no dedicated "scheduled" field on the order.
export const NOT_SCHEDULED_DATE = "01/01/2999";

export const orderStatusConstants = {
  PAID: "Paid",
  EXPIRED: "Expired",
  DELETED: "Deleted",
  REFUNDED: "Refunded",
  SENT_TO_PATIENT: "SentToPatient",
  CANCELED: "Canceled",
  DRAFT: "Draft",
  PARTIALLY_PAID: "PartiallyPaid",
  NO_BALANCE_DUE: "NoBalanceDue",
  PAID_VIA_CASH_UNMANAGED: "PaidViaCashUnmanaged",
};

export const orderStatusMapping = {
  [orderStatusConstants.SENT_TO_PATIENT]: "Sent",
  [orderStatusConstants.DELETED]: "Deleted",
  [orderStatusConstants.EXPIRED]: "Expired",
  [orderStatusConstants.PAID]: "Paid",
  [orderStatusConstants.PARTIALLY_PAID]: "Partial",
  [orderStatusConstants.REFUNDED]: "Refunded",
  [orderStatusConstants.CANCELED]: "Canceled",
  [orderStatusConstants.DRAFT]: "Action Needed",
  [orderStatusConstants.NO_BALANCE_DUE]: "No Balance Due",
  [orderStatusConstants.PAID_VIA_CASH_UNMANAGED]: "Paid via Cash",
};

export const orderStatusChipVariantsMapping = {
  [orderStatusConstants.SENT_TO_PATIENT]: ChipVariants.WARNING,
  [orderStatusConstants.DELETED]: ChipVariants.WARNING,
  [orderStatusConstants.EXPIRED]: ChipVariants.EXPIRED,
  [orderStatusConstants.PAID]: ChipVariants.SUCCESS,
  [orderStatusConstants.PARTIALLY_PAID]: ChipVariants.WARNING,
  [orderStatusConstants.REFUNDED]: ChipVariants.EXPIRED,
  [orderStatusConstants.CANCELED]: ChipVariants.EXPIRED,
  [orderStatusConstants.DRAFT]: ChipVariants.EXPIRED,
  [orderStatusConstants.NO_BALANCE_DUE]: ChipVariants.EXPIRED,
  [orderStatusConstants.PAID_VIA_CASH_UNMANAGED]: ChipVariants.SUCCESS,
};

export const orderTypeMapping = {
  [orderTypeConstants.ED]: "ER",
  [orderTypeConstants.BARIATRICS]: "Bariatrics",
  [orderTypeConstants.BUNDLED]: "Clear Package",
  [orderTypeConstants.PATIENT_RESPONSIBILITY]: "Patient Balance",
  [orderTypeConstants.GFE]: "Patient Estimate",
};

export const orderTypeShortMapping = {
  [orderTypeConstants.ED]: "ER",
  [orderTypeConstants.BARIATRICS]: "Bariatrics",
  [orderTypeConstants.BUNDLED]: "Clear Package",
  [orderTypeConstants.PATIENT_RESPONSIBILITY]: "Patient Balance",
  [orderTypeConstants.GFE]: "Patient Estimate",
};

export const ED_ORDER_TYPE_EXPIRATION_PERIOD = 10;

export const payerTypeConstants = {
  COMMERCIAL: "Commercial",
  MEDICARE_ADVANTAGE: "UhcMedicareAdvantage",
  MEDICARE: "OriginalMedicare",
  MEDICAID: "Medicaid",
};
